/**
 * 修复 Error 对象无法在 postMessage 中传递的问题
 */
export const formatError = (error: any = {}, apiName: string) => {
  if (!(error instanceof Error)) {
    return { error };
  }

  if (apiName === 'request') {
    return {
      error: 12, // 网络错误
      errorMessage: error.message
    }
  }
  return JSON.parse(
    JSON.stringify(error, Object.getOwnPropertyNames(error))
  );
}